import React, { useState } from 'react'
import { connect } from 'react-redux'

import DetailsHolder from '../DetailsHolder'
import Personnel from '../../../College/PersonnelForm'
import FormDropdown from '../../../../Components/FormField/FormDropdown'

const CollegeDetailPersonnel = ({ college }) => {
  const persRef = React.useRef()
  const [refNameIdx, setRefNameIdx] = useState(0)

  const getRefNameList = () => {
    var refList = []

    for (var i = 0; i < college.personnel.length; i++) {
      if (college.personnel[i]) {
        const refName = {
          name:
            'reference_name' in college.personnel[i]
              ? college.personnel[i].reference_name
              : 'default_ref',
          value: i,
        }
        refList.push(refName)
      }
    }

    return refList
  }

  const refNameChanged = (e) => {
    const newIndex = parseInt(e.target.value, 0)
    setRefNameIdx(newIndex)
    persRef.current.swapTab(college.personnel, newIndex)
  }

  const buildRefNameOption = () => {
    const optionList = []
    const refNameList = getRefNameList()
    if (refNameList) {
      refNameList.map((item) => {
        optionList.push(<option value={item.value}>{item.name}</option>)
      })
    }

    return optionList
  }

  return (
    <DetailsHolder college={college} activePath='/CollegeDetailPersonnel'>
      {college.personnel.length > 0 && (
        <div className='ml-2 col-3'>
          <FormDropdown label='Reference Name List: ' onChange={refNameChanged}>
            {buildRefNameOption()}
          </FormDropdown>
        </div>
      )}
      <div style={{ pointerEvents: 'none' }}>
        {college.personnel.length == 0 ? (
          <div className='absolute-align-items-center'>
            <p>Currently there is no data available.</p>
          </div>
        ) : (
          <Personnel
            campuses={college.campuses}
            personnel={college.personnel}
            user={college.user}
            current_index={refNameIdx}
            ref={persRef}
            isViewAsAdmin={true}
          />
        )}
      </div>
    </DetailsHolder>
  )
}

function mapStateToProps(state) {
  return {
    college: state.admin.college_details,
  }
}

export default connect(mapStateToProps)(CollegeDetailPersonnel)
